import { useState, useMemo } from "react";
import { Icon } from "@aidron/aidron-ds";
import { ModalTemplate } from "../sharedComponents.index";
import Modal from "react-modal";
import PropTypes from "prop-types";

export function IconButtonWithModal({ icon, modalHeading, renderModalContent, useStyledModal = false, style = {} }) {
  const [openModal, setOpenModal] = useState(false);

  function onCloseModal() {
    setOpenModal(false);
  }

  const modalContent = useMemo(
    () => renderModalContent({ closeModal: onCloseModal }),
    [renderModalContent]
  );

  return (
    <section style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', ...style }}>
      <button
        onClick={(e) => { e.stopPropagation(); setOpenModal(true); }}
        style={{
          display: 'inline-block',
          textAlign: 'center',
          cursor: 'pointer',
          border: 'none',
          background: 'none',
          padding: 0,
          margin: 0,
          font: 'inherit',
          color: '#f26f21',
          marginLeft: '5px',
          verticalAlign: 'text-top',
        }}
      >
        <Icon icon={icon} size={17} />
      </button>

      {useStyledModal ? (
        <IconButtonWithModal.StylesForModal isOpen={openModal} onClose={onCloseModal} heading={modalHeading}>
          {modalContent}
        </IconButtonWithModal.StylesForModal>
      ) : (
        <div style={{ display: openModal ? 'block' : 'none' }}>
          <ModalTemplate open={openModal} width="700px" heading={modalHeading} closingFunction={onCloseModal}>
            {modalContent}
          </ModalTemplate>
        </div>
      )}
    </section>
  );
};

IconButtonWithModal.StylesForModal = StyledModal;

function StyledModal({ isOpen, onClose, heading, children }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      style={{
        overlay: {
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(2px)'
        },
        content: {
          position: 'relative',
          inset: 'unset',
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '32px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          border: 'none',
        }
      }}
      contentLabel={heading}
    >
      {heading && <strong style={{ fontSize: '1rem' }}>{heading}</strong>}
      {children}
    </Modal>
  );
}

IconButtonWithModal.propTypes = {
  icon: PropTypes.string,
  modalHeading: PropTypes.string,
  renderModalContent: PropTypes.func,
  useStyledModal: PropTypes.bool,
};

StyledModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  children: PropTypes.node,
};